<div class="inline-div">
  @if (data) {
    @if (data.data$|async; as obj) {
      <a uiSref="a.price.check" [uiParams]="{id: obj.oa_nr}"
        target="_blank"
        class="label label-warning">
        Zum Schwesterartikel
      </a>
    } @else {
      <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
    }
    <loading-or-error
      #loadingOrError
      [loadingWrapper]="data"
      [errorMessage]="'Konnte \'Schwester Artikel\' nicht laden'"
      [spinnerSize]="2"
      spinnerName="circle-o-notch">
    </loading-or-error>
  }
</div>
